var map = {
	"./gallery - story - bard (1)_00.jpg": 2536,
	"./gallery - story - bard (1)_01.jpg": 2537,
	"./gallery - story - bard (1)_02.jpg": 2538,
	"./gallery - story - bard (1)_03.jpg": 2539,
	"./gallery_00.jpg": 2540,
	"./gallery_01.jpg": 2541,
	"./gallery_02.jpg": 2542,
	"./gallery_03.jpg": 2543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2535;